export default __webpack_public_path__ + "static/media/TerraGreen.73d8be21.svg";